// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3rKAr","right":"Footer_right__1Rlll","buttons":"Footer_buttons__J2K1O"};